// The member page's line under "Face Verification" (2026-10-14): which part
// of the last face check failed. Fed by the backend's user_details
// faceCheckLast (the newest face_verification_attempt, with no scores and no
// links). Staff only. No dashes; never "match" about people. Rows exist only
// for checks made while one of the eyes switches was ON; an older check
// shows its outcome alone.

const EYES_WHY = {
  sunglasses: "sunglasses in the selfie",
  eyes_covered: "the face is covered in the selfie",
  faces: "more than one face in the selfie",
};

const PHOTO_WHY = {
  sunglasses: "sunglasses",
  eyes_covered: "face covered",
  small: "face too small",
  no_face: "no face",
  unchecked: "not checked",
};

const REASON = {
  no_match: "the selfie did not look enough like the photos",
  liveness: "not a live photo (liveness)",
  photos_unclear: "no photo shows the face clearly",
  provider_error: "an error on our side (the checking service)",
  handler_error: "an error on our side",
};

// Why the clear photo rule did not stop a check (backend utils/faceClear).
const NOT_ENFORCED = {
  off: "the clear photo rule is OFF",
  change_photos_off: "Change My Photos is OFF",
  older_app: "app older than 2.5 during sign-up",
};

/** Pure. The words for one photo's clarity, or null for a clear one. */
export const photoWords = (p) => {
  if (!p || p.clear === true) return null;
  return PHOTO_WHY[p.why] || (p.clear === null ? "not checked" : "unclear");
};

/**
 * Pure. { title, detail } for the last face check, or null when there was
 * none. title: "Passed" or "Did not pass: <why>"; detail: a selfie in
 * sunglasses let through, and what the photo rule found, when it looked.
 */
export const faceCheckSummary = (last) => {
  if (!last) return null;
  let title;
  if (last.success) title = "Passed";
  else if (last.failureReason === "selfie_eyes") {
    title = `Did not pass: ${EYES_WHY[last.eyes && last.eyes.why] || "the eyes are not visible in the selfie"}`;
  } else {
    title = `Did not pass: ${REASON[last.failureReason] || "no reason recorded"}`;
  }
  const parts = [];
  if (last.eyes && last.eyes.waived) {
    parts.push(
      "Selfie in sunglasses, let through so the member is not stuck: none of the photos shows the face clearly, a selfie with the eyes showing had not passed, and the app cannot go back to the photos during sign-up. The admin bell rang."
    );
  }
  const ph = last.photos;
  if (ph && Array.isArray(ph.perPhoto)) {
    const list = ph.perPhoto.map((p, i) => `photo ${i + 1}: ${photoWords(p) || "clear"}`).join(", ");
    if (!ph.enforced && ph.rule !== "off" && (ph.allUnclear || ph.passOnlyThroughUnclear)) {
      const why = NOT_ENFORCED[ph.rule] || "not enforced here";
      const would = last.success ? "this check would not have passed" : "it would have said no photo shows the face clearly";
      parts.push(`Photos: ${list}. Not enforced on this check (${why}); enforced, ${would}.`);
    } else parts.push(`Photos: ${list}.`);
  }
  return { title, detail: parts.length ? parts.join(" ") : null };
};
